import React from 'react'
import PropTypes from 'prop-types'
import { ConfigurationModal } from 'components/ConfigurationModal'
import { OrganizationTeamModal } from 'components/OrganizationTeamModal'
import { SchedulerDenyPermissionModal } from 'components/SchedulerDenyPermissionModal'
import { PaymentAccountModal } from 'components/PaymentAccountModal'
import { AccountPlanModal } from 'components/AccountPlanModal'
import { TransactionModal } from 'components/TransactionModal'
import { EditTenantModal } from 'components/EditTenantModal'
import { EditTenantOwnerIdentityModal } from 'components/EditTenantOwnerIdentityModal'
import { AWSCredentialsModal } from 'components/AWSCredentialsModal'
import { SMSActivationModal } from 'components/SMSActivation/Index'
import { ChangeCallbackUriModal } from 'components/WabaChangeCallbackUriModal'
import { ChangePhoneNumberWebhookUriModal } from 'components/ChangePhoneNumberWebhookUriModal'
import { CloudApiModal } from 'components/CloudApi'
import { AuthorizationKeyModal } from 'components/GetAuthorizationKeyModal'
import { ShowAuthorizationKeyModal } from 'components/ShowAuthorizationKeyModal'
import { SetAiAgentsPlanModal } from 'components/SetAiAgentsPlanModal'

export const MODAL_TYPES = {
  AddConfiguration: 'AddConfiguration',
  EditConfiguration: 'EditConfiguration',
  AddTemOrganization: 'AddTemOrganization',
  RemoveTemOrganization: 'RemoveTemOrganization',
  SchedulerDenyPermission: 'SchedulerDenyPermission',
  EditPaymentAccount: 'EditPaymentAccount',
  EditAccountPlan: 'EditAccountPlan',
  EditTenant: 'EditTenant',
  EditTenantOwnerIdentity: 'EditTenantOwnerIdentity',
  PerformTransaction: 'PerformTransaction',
  AWSCredentials: 'AWSCredentials',
  SMSActivation: 'SMSActivation',
  ChangeCallbackUri: 'ChangeCallbackUri',
  ChangePhoneNumberWebhookUri: 'ChangePhoneNumberWebhookUri',
  CloudApi: 'CloudApi',
  GetAuthorizationKey: 'GetAuthorizationKey',
  ShowAuthorizationKey: 'ShowAuthorizationKey',
  SetAiAgentsPlan: 'SetAiAgentsPlan'
}

export function ModalFactory(props) {
  switch (props.type) {
    case MODAL_TYPES.AddConfiguration:
    case MODAL_TYPES.EditConfiguration:
      return <ConfigurationModal {...props} />
    case MODAL_TYPES.AddTemOrganization:
    case MODAL_TYPES.RemoveTemOrganization:
      return <OrganizationTeamModal {...props} />
    case MODAL_TYPES.SchedulerDenyPermission:
      return <SchedulerDenyPermissionModal {...props} />
    case MODAL_TYPES.EditPaymentAccount:
      return <PaymentAccountModal {...props} />
    case MODAL_TYPES.EditAccountPlan:
      return <AccountPlanModal {...props} />
    case MODAL_TYPES.PerformTransaction:
      return <TransactionModal {...props} />
    case MODAL_TYPES.EditTenant:
      return <EditTenantModal {...props} />
    case MODAL_TYPES.EditTenantOwnerIdentity:
      return <EditTenantOwnerIdentityModal {...props} />
    case MODAL_TYPES.AWSCredentials:
      return <AWSCredentialsModal {...props} />
    case MODAL_TYPES.SMSActivation:
      return <SMSActivationModal {...props} />
    case MODAL_TYPES.ChangeCallbackUri:
      return <ChangeCallbackUriModal {...props} />
    case MODAL_TYPES.ChangePhoneNumberWebhookUri:
      return <ChangePhoneNumberWebhookUriModal {...props} />
    case MODAL_TYPES.CloudApi:
      return <CloudApiModal {...props} />
    case MODAL_TYPES.GetAuthorizationKey:
      return <AuthorizationKeyModal {...props} />
    case MODAL_TYPES.ShowAuthorizationKey:
      return <ShowAuthorizationKeyModal {...props} />
    case MODAL_TYPES.SetAiAgentsPlan:
      return <SetAiAgentsPlanModal {...props} />
    default:
      return <ConfigurationModal {...props} visible={false} />
  }
}

ModalFactory.propTypes = {
  organization: PropTypes.string,
  chatbot: PropTypes.string,
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  loading: PropTypes.bool,
  record: PropTypes.object,
  wrappedComponentRef: PropTypes.any,
  type: PropTypes.string,
  maskClosable: PropTypes.bool
}
